import { Helmet } from 'react-helmet-async';
import { LEGAL_CONFIG } from '@/legal/config';

const ORIGIN = `https://${LEGAL_CONFIG.domain.primary}`;

/**
 * Per-route SEO head: title, description, canonical, Open Graph, Twitter,
 * robots directives and optional JSON-LD.
 */
export default function SeoHead({
  title,
  description,
  path = '/',
  image = `${ORIGIN}/og-image.png`,
  type = 'website',
  noindex = false,
  jsonLd = null,
}) {
  const url = `${ORIGIN}${path}`;
  const fullTitle = title?.includes('InkPhD') ? title : `${title} · InkPhD`;
  return (
    <Helmet prioritizeSeoTags>
      <title>{fullTitle}</title>
      <meta name="description" content={description} />
      <link rel="canonical" href={url} />
      <meta name="robots" content={noindex ? 'noindex, nofollow' : 'index, follow, max-image-preview:large'} />
      <meta property="og:type" content={type} />
      <meta property="og:title" content={fullTitle} />
      <meta property="og:description" content={description} />
      <meta property="og:url" content={url} />
      <meta property="og:image" content={image} />
      <meta property="og:site_name" content="InkPhD" />
      <meta property="og:locale" content="en_GB" />
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={fullTitle} />
      <meta name="twitter:description" content={description} />
      <meta name="twitter:image" content={image} />
      {jsonLd && <script type="application/ld+json">{JSON.stringify(jsonLd)}</script>}
    </Helmet>
  );
}

export { ORIGIN };
